module.exports = __webpack_public_path__ + "img/ezzebank-name-color-shadow.521f48a1.png";